import { Application } from '@hotwired/stimulus';

import Accordion from './accordion';
import Burger from './burger';
import FormContact from './form-contact';

const application = Application.start();

application.register('accordion', Accordion);
application.register('burger', Burger);
application.register('form-contact', FormContact);
